(() => {
  'use strict';
  const layer = document.querySelector('.apple-playground');
  const controls = document.querySelector('.apple-controls');
  const hero = document.querySelector('.hero');
  const signup = document.querySelector('#noutati');
  if (!layer || !window.PointerEvent) return;
  const reduced = matchMedia('(prefers-reduced-motion: reduce)');
  const clamp = (n,low,high) => Math.max(low,Math.min(high,n));
  const apples = [...layer.querySelectorAll('.play-apple')].map((el,index) => ({el,index,x:0,y:0,vx:0,vy:0,angle:index*17-20,spin:0,pointer:null,samples:[]}));
  let width=innerWidth,height=innerHeight,size=96,frame=0,lastTime=0,obstacles=[],lastObstacles=0,enabled=true,playAreaAllowed=false;
  const motionAllowed = () => !reduced.matches && !document.body.classList.contains('motion-paused');
  function readObstacles() {
    obstacles=[...document.querySelectorAll('a,button,input,select,textarea,#preview-form,#noutati')]
      .filter(el=>!el.closest('.apple-playground'))
      .map(el=>el.getBoundingClientRect())
      .filter(r=>r.width>0&&r.height>0&&r.bottom>0&&r.top<height&&r.right>0&&r.left<width)
      .map(r=>({left:r.left-5,right:r.right+5,top:r.top-5,bottom:r.bottom+5}));
    lastObstacles=performance.now();
  }
  function paint(a) { a.el.style.transform=`translate3d(${a.x.toFixed(2)}px,${a.y.toFixed(2)}px,0)`; a.el.firstElementChild.style.transform=`rotate(${a.angle.toFixed(2)}deg)`; }
  function walls(a) {
    if(a.x<2){a.x=2;a.vx=Math.abs(a.vx)*.73;}
    if(a.x>width-size-2){a.x=width-size-2;a.vx=-Math.abs(a.vx)*.73;}
    if(a.y<4){a.y=4;a.vy=Math.abs(a.vy)*.73;}
    if(a.y>height-size-4){a.y=height-size-4;a.vy=-Math.abs(a.vy)*.73;}
  }
  function avoidControls(a) {
    // Resolve the smallest feasible displacement. Apples never rest on a CTA or input.
    for(let pass=0;pass<3;pass++) for(const r of obstacles){
      if(a.x>=r.right||a.x+size<=r.left||a.y>=r.bottom||a.y+size<=r.top) continue;
      const moves=[{axis:'x',value:r.left-size-1},{axis:'x',value:r.right+1},{axis:'y',value:r.top-size-1},{axis:'y',value:r.bottom+1}]
        .filter(m=>m.value>=4&&m.value<=(m.axis==='x'?width:height)-size-4)
        .sort((u,v)=>Math.abs(u.value-a[u.axis])-Math.abs(v.value-a[v.axis]));
      if(!moves.length) continue;
      const m=moves[0];a[m.axis]=m.value;a[m.axis==='x'?'vx':'vy']*=-.55;
    }
    walls(a);
  }
  function separateApples() {
    for(let i=0;i<apples.length;i++)for(let j=i+1;j<apples.length;j++){
      const a=apples[i],b=apples[j],dx=b.x-a.x,dy=b.y-a.y,d=Math.hypot(dx,dy),minimum=size*.85;
      if(d>=minimum)continue;
      const nx=d?dx/d:1,ny=d?dy/d:0,overlap=minimum-d;
      if(a.pointer===null){a.x-=nx*overlap*(b.pointer===null?.5:1);a.y-=ny*overlap*(b.pointer===null?.5:1);}
      if(b.pointer===null){b.x+=nx*overlap*(a.pointer===null?.5:1);b.y+=ny*overlap*(a.pointer===null?.5:1);}
      const relative=(b.vx-a.vx)*nx+(b.vy-a.vy)*ny;
      if(relative<0){const impulse=-relative*.8;if(a.pointer===null){a.vx-=impulse*nx;a.vy-=impulse*ny;a.spin-=impulse*.07;}if(b.pointer===null){b.vx+=impulse*nx;b.vy+=impulse*ny;b.spin+=impulse*.07;}}
    }
  }
  function stop() {
    cancelAnimationFrame(frame);frame=0;lastTime=0;
    apples.forEach(a=>{a.vx=0;a.vy=0;a.spin=0;});
  }
  function tick(now) {
    frame=0;
    if(!enabled||!playAreaAllowed||document.hidden){stop();return;}
    const dt=Math.min(.032,(now-(lastTime||now))/1000);lastTime=now;
    if(now-lastObstacles>120)readObstacles();
    let moving=false;
    for(const a of apples){
      if(a.pointer!==null)continue;
      if(!motionAllowed()){a.vx=0;a.vy=0;a.spin=0;}
      a.x+=a.vx*dt;a.y+=a.vy*dt;a.angle+=a.spin*dt;
      const drag=Math.exp(-1.35*dt);a.vx*=drag;a.vy*=drag;a.spin*=drag;
      walls(a);
    }
    separateApples();
    for(const a of apples){
      if(a.pointer===null)avoidControls(a);
      if(Math.hypot(a.vx,a.vy)<7){a.vx=0;a.vy=0;a.spin=0;}
      else moving=true;
      paint(a);
    }
    if(moving)frame=requestAnimationFrame(tick);else lastTime=0;
  }
  function wake(){if(!frame&&enabled&&playAreaAllowed&&!document.hidden)frame=requestAnimationFrame(tick);}
  function reset(){
    stop();width=innerWidth;height=innerHeight;size=width<700?64:width<1100?80:108;
    layer.style.setProperty('--apple-size',`${size}px`);
    const homes=[[8,height*.37],[width-size-8,height*.27],[width-size-12,height*.64]];
    readObstacles();
    apples.forEach((a,i)=>{const pointer=a.pointer;a.pointer=null;if(pointer!==null&&a.el.hasPointerCapture(pointer))a.el.releasePointerCapture(pointer);a.el.classList.remove('is-grabbed');a.x=homes[i][0];a.y=clamp(homes[i][1],4,height-size-4);a.angle=i*17-20;avoidControls(a);paint(a);});
  }
  function toss(a){
    if(motionAllowed()){a.vx=(a.x+size/2<width/2?1:-1)*(380+a.index*75);a.vy=-220-a.index*35;a.spin=a.vx*.32;wake();}
    else{a.x+=a.x<width/2?38:-38;a.y-=24;avoidControls(a);paint(a);}
  }
  function record(a,event){a.samples.push({x:event.clientX,y:event.clientY,t:event.timeStamp});while(a.samples.length>2&&event.timeStamp-a.samples[0].t>110)a.samples.shift();}
  for(const a of apples){
    a.el.addEventListener('dragstart',e=>e.preventDefault());
    a.el.addEventListener('pointerdown',e=>{
      if(!enabled||!playAreaAllowed||a.pointer!==null||(e.pointerType==='mouse'&&e.button!==0))return;
      e.preventDefault();a.pointer=e.pointerId;a.vx=0;a.vy=0;a.spin=0;a.offsetX=e.clientX-a.x;a.offsetY=e.clientY-a.y;a.startX=e.clientX;a.startY=e.clientY;a.samples=[];record(a,e);
      a.el.setPointerCapture(e.pointerId);a.el.classList.add('is-grabbed');
    });
    a.el.addEventListener('pointermove',e=>{
      if(a.pointer!==e.pointerId)return;
      a.x=clamp(e.clientX-a.offsetX,2,width-size-2);a.y=clamp(e.clientY-a.offsetY,4,height-size-4);record(a,e);paint(a);
    });
    function release(e,cancelled){
      if(a.pointer!==e.pointerId)return;
      a.pointer=null;a.el.classList.remove('is-grabbed');if(a.el.hasPointerCapture(e.pointerId))a.el.releasePointerCapture(e.pointerId);
      readObstacles();
      if(cancelled){a.vx=a.vy=a.spin=0;avoidControls(a);paint(a);return;}
      record(a,e);
      if(Math.hypot(e.clientX-a.startX,e.clientY-a.startY)<7){toss(a);return;}
      const first=a.samples[0],last=a.samples[a.samples.length-1],dt=Math.max(16,last.t-first.t)/1000;
      if(motionAllowed()){a.vx=clamp((last.x-first.x)/dt,-1500,1500);a.vy=clamp((last.y-first.y)/dt,-1500,1500);a.spin=a.vx*.24;}
      else{a.vx=a.vy=a.spin=0;}
      avoidControls(a);paint(a);wake();
    }
    a.el.addEventListener('pointerup',e=>release(e,false));
    a.el.addEventListener('pointercancel',e=>release(e,true));
    a.el.addEventListener('lostpointercapture',e=>release(e,true));
    a.el.addEventListener('click',e=>{if(e.detail===0)toss(a);});
    a.el.addEventListener('keydown',e=>{
      const direction={ArrowLeft:[-30,0],ArrowRight:[30,0],ArrowUp:[0,-30],ArrowDown:[0,30]}[e.key];
      if(!direction)return;e.preventDefault();a.vx=a.vy=a.spin=0;a.x+=direction[0];a.y+=direction[1];readObstacles();avoidControls(a);paint(a);
    });
  }
  document.querySelector('#reset-apples').addEventListener('click',reset);
  document.querySelector('#toggle-apples').addEventListener('click',e=>{
    enabled=!enabled;layer.hidden=!enabled||!playAreaAllowed;stop();e.currentTarget.setAttribute('aria-pressed',String(enabled));e.currentTarget.setAttribute('aria-label',enabled?'Ascunde merele de joacă':'Arată merele de joacă');e.currentTarget.textContent=enabled?'×':'+';if(enabled)reset();
  });
  function overlapsViewport(element) {
    if (!element || element.hidden) return false;
    const box = element.getBoundingClientRect();
    return box.width > 0 && box.height > 0 && box.top < height && box.bottom > 0;
  }
  function syncPlayArea() {
    // Keep the hero, signup card and their controls clear. The user's manual
    // on/off preference is preserved when play returns farther down the page.
    const allowed = !overlapsViewport(hero) && !overlapsViewport(signup);
    if (allowed !== playAreaAllowed) { playAreaAllowed = allowed; reset(); }
    layer.hidden = !enabled || !playAreaAllowed;
    controls.hidden = !playAreaAllowed;
    document.body.classList.toggle('apples-ready', playAreaAllowed);
  }
  function settle(){readObstacles();apples.forEach(a=>{if(a.pointer===null){avoidControls(a);paint(a);}});}
  let scrollFrame=0;
  addEventListener('scroll',()=>{if(!scrollFrame)scrollFrame=requestAnimationFrame(()=>{scrollFrame=0;syncPlayArea();if(playAreaAllowed)settle();});},{passive:true});
  addEventListener('resize',()=>{reset();syncPlayArea();},{passive:true});
  document.addEventListener('bf:phasechange',()=>{syncPlayArea();settle();});
  if (signup) new ResizeObserver(()=>{syncPlayArea();settle();}).observe(signup);
  addEventListener('blur',()=>{apples.forEach(a=>{a.pointer=null;a.el.classList.remove('is-grabbed');});stop();});
  document.addEventListener('visibilitychange',()=>{if(document.hidden)stop();});
  new MutationObserver(()=>{if(!motionAllowed())stop();}).observe(document.body,{attributes:true,attributeFilter:['class']});
  reduced.addEventListener('change',()=>{if(reduced.matches)stop();});
  reset();syncPlayArea();
})();
